// askFreeCache.ts — last-known count of free Ask questions left for a non-member, kept per
// user id so the UI can tell when the taster is used up without a round trip. The server
// is the authority; this only decides what to offer. Storage failures are non-events.
// MUST match FREE_LIMIT in server/src/lib/askFree.js.
export const ASK_FREE_LIMIT = 2;
const key = (userId: string | null | undefined) => `renurture.ask.free.v1.${userId || 'anon'}`;

/** Free questions left, or null when unknown (never asked, or storage blocked). */
export function readFreeRemaining(userId: string | null | undefined): number | null {
  try {
    const raw = localStorage.getItem(key(userId));
    if (raw == null) return null;
    const n = Number(raw);
    return Number.isInteger(n) && n >= 0 ? Math.min(n, ASK_FREE_LIMIT) : null;
  } catch { return null; }
}

export function writeFreeRemaining(userId: string | null | undefined, n: number): void {
  try { localStorage.setItem(key(userId), String(Math.max(0, Math.floor(n)))); } catch { /* ignore */ }
}
